import { Component, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { interval, Subject, Subscription } from 'rxjs';
import { CampaignCrudUrlBuilder } from '../../../campaign-util/shared/crud-url-builder';

@Component({
  selector: 'job-progress',
  templateUrl: './progress.component.html'
})
export class ProgressComponent implements OnChanges {

  @Input('job') job: any;
  @Input('message') message: string;
  @Input('interval') interval: number = 5;
  @Output('onFinish') onFinish: Subject<any> = new Subject<any>();

  inProgress: boolean = false;
  error: string = '';
  subscription: Subscription;

  constructor(private httpClient: HttpClient,
              private urlBuilder: CampaignCrudUrlBuilder) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.job && changes.job.currentValue) {
      this.inProgress = true;
      this.subscription = interval(this.interval * 1000)
        .subscribe(
          () => {
            this.getJobStatus();
          }
        );
    }
  }

  getJobStatus(): void {
    this.httpClient.get(this.urlBuilder.buildUrl('/job/' + this.job.id))
      .subscribe(
        (response: any) => {
          if (response.status === 'finished' || response.status === 'error') {
            this.subscription.unsubscribe();
            this.inProgress = false;

            this.error = response.error;

            if (this.onFinish instanceof Subject) {
              this.onFinish.next(response);
            }
          }
        }
      );
  }
}
